import type { ChapterSectionDependency } from '@shared/chapterSectionDependencies'
import React from 'react'

import DependencyChips from './DependencyChips'
import type { SectionDependencyView } from '../../hooks/useSectionDependencies'

interface SectionDependencyChipProps {
  sectionKey: string
  view: SectionDependencyView
  bookDirection: 'ltr' | 'rtl'
  bookFontFamily?: string
  onRemove: (depId: string) => void
  onEdit: (dep: ChapterSectionDependency) => void
}

/**
 * Drop-in chip for any row that represents a ChapterSection, in any of the views that
 * list them. Renders nothing when the section has no dependencies, so it can sit in a
 * dense row without costing space in the common case.
 */
export default function SectionDependencyChip({
  sectionKey,
  view,
  bookDirection,
  bookFontFamily,
  onRemove,
  onEdit,
}: SectionDependencyChipProps) {
  const outgoing = view.outgoingByKey.get(sectionKey) ?? []
  const incoming = view.incomingByKey.get(sectionKey) ?? []
  if (outgoing.length === 0 && incoming.length === 0) {
    return null
  }
  return (
    <DependencyChips
      outgoing={outgoing}
      incoming={incoming}
      violations={view.violations}
      bookDirection={bookDirection}
      bookFontFamily={bookFontFamily}
      labelByKey={view.labelByKey}
      onRemove={onRemove}
      onEdit={onEdit}
    />
  )
}
